import React from 'react';
import { Clock, DollarSign, Users, Leaf, Shield, MapPin } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: MapPin,
      title: 'Locally Owned & Operated',
      description: 'We\'re part of the Hamilton community and proud to serve our neighbors with reliable junk removal services.'
    },
    {
      icon: Clock,
      title: 'Fast Response Times',
      description: 'Same-day and next-day service available. Our trucks hold up to 14 yards. We work around your schedule to get the job done quickly.'
    },
    {
      icon: DollarSign,
      title: 'Upfront Pricing',
      description: 'No hidden fees or surprises. You\'ll know the exact cost before we start. Free, no-obligation quotes.'
    },
    {
      icon: Users,
      title: 'Friendly, Professional Service',
      description: 'Our experienced team treats your property with respect and ensures a smooth, hassle-free experience.'
    },
    {
      icon: Leaf,
      title: 'Eco-Friendly Disposal',
      description: 'We donate, recycle, and dispose responsibly. Minimizing landfill waste is our priority.'
    },
    {
      icon: Shield,
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured for your peace of mind. We handle all items safely and professionally.'
    }
  ];

  return (
    <section className="py-20 bg-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Why Choose JUNKio?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're committed to providing the best junk removal experience in Hamilton with fast, affordable, and eco-friendly service.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div 
                key={index} 
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
              >
                <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Icon className="w-8 h-8 text-emerald-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
                <p className="text-gray-600 leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;